import { encapsulateStyle } from '@angular/compiler';
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ILoginModel } from 'src/app/models/loginModel';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {

  adminLoginForm: FormGroup;

  public loginModel: ILoginModel = {
    email: "",
    password: ""
  }

  constructor(private formBuilder: FormBuilder, private _router: Router, private _ref: ChangeDetectorRef,
    private _authService: AuthService, private _spinner: NgxSpinnerService) {
    this.adminLoginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(3)]]
    });
  }

  ngOnInit() {
  }

  saveEventRegistration() {
    if (!this.adminLoginForm.valid) {
      alert("Please enter valid admin credentials.");
      this.adminLoginForm.markAllAsTouched();
      return;
    } else {
      this._spinner.show();
      this._authService.authentication(this.adminLoginForm.value).subscribe({
        next: (response: any) => {
          if (response && response.hasOwnProperty('token')) {
            localStorage.setItem('token', response.token);
            this._router.navigateByUrl('/admin/admin-blogs');
          } else {
            alert("Invalid admin credentials.");
          }

          this._spinner.hide();
          setTimeout(() => {
            this._ref.markForCheck();
          }, 1000);
        },
        error: (error) => {
          this._spinner.hide();
          console.log(error);
          this._ref.markForCheck();
        },
      });
    }
  }
}
